export default "__VITE_ASSET__BXY9dMTF__"